import { ZIndexOptions } from '@mui/material/styles/zIndex';

const Z_INDEX_OFFSET = 2147483100; // z-index value which is higher than intercom z-index

export const Z_INDEX_OVERLAY = 999 + Z_INDEX_OFFSET;

export const zIndex: ZIndexOptions = {
  speedDial: 50 + Z_INDEX_OFFSET,
  appBar: 50 + Z_INDEX_OFFSET,
  drawer: 100 + Z_INDEX_OFFSET,
  modal: 150 + Z_INDEX_OFFSET,
  snackbar: 200 + Z_INDEX_OFFSET,
  tooltip: 250 + Z_INDEX_OFFSET,
  fab: 300 + Z_INDEX_OFFSET,
};
